<script setup>
import CloudCard from '@/components/ui/CloudCard.vue'
</script>

<template>
  <section class="section">
    <div class="wrap" style="display:grid; gap: var(--sp-6);">
      <h1>Spirituele coaching</h1>

      <div class="grid-2">
        <CloudCard tone="primary">
          <p>
            Tijdens mijn H.E.A.O. studietijd en daarna vond ik me regelmatig, ’s-ochtends,  in discussie met aanhangers van gelovigen (Jesus , Mohamed, Krishna), Guru's (Baghwan, Andrew Cohen, etc) en Anti-Guru's (Krishnamurti, Loesje,etc). Nooit kon ik hen uitleggen waarom ik niet pro de één of con de ander was. Ik zag het goede in ze allemaal! Het draaide om het stuk "jouw vertellen wat je moet doen of laten".<br><br>
            Totdat een leraar, tijdens een hoorcollege over begeleiding van cliënten het volgende vertelde. "Ik ben helemaal niet geïnteresseerd in jullie. In methodieken, in systemen. Mij gaat het om de cliënt achter jullie. En hij tekende een vliegtuig op het schoolbord met 1 grote motor en een schijnbaar vage, onbelangrijke stip aan de achterkant van het vliegtuig. Dit, en hij maakte een cirkel om de vliegtuig, is de cliënt. En dit, en hij omcirkelde de motor is de wil, de wensen, de vraag van de cliënt . En dit, en hij omcirkelde de vage stip zijn wij. De begeleiders, de ondersteuners. Niets meer dan een HULP-motor voor de echte motor.<br><br>
            Wat kan ik je bieden? Bijvoorbeeld een 3 maanden durende persoonlijk traject, waarin ik je reisgenoot/begeleider zal zijn naar jouw nieuwe werkelijkheid. In de reis zitten onder andere <router-link to="/wat-is-reiki" class="jargon-link">Reiki</router-link>- en <router-link to="/elementen-healing" class="jargon-link">Elementen</router-link> behandelingen en <router-link to="/wat-is-leela" class="jargon-link">Leela</router-link>-sessies<br><br>
            Laat je meevoeren door het geluid van het Multi-Versum en wordt het geluid dat je al bent.<br><br>
            AUM
          </p>
        </CloudCard>
      </div>

      <div>
        <h2>Recensies</h2>
        <img src="/images/spiritual-2.jpg" alt="Sfeerbeeld" class="card" />
      </div>

      <div class="actions">
        <router-link class="btn btn-primary" to="/contact-2">Vrijblijvend kennismaken</router-link>
        <router-link class="btn btn-ghost" to="/spiritueel">Terug naar home</router-link>
      </div>
    </div>
  </section>
</template>

